import styled from 'styled-components';
import {mobileMedia, scrollbar} from '../../../../../../globalVariables/GlobalVariables';

export const modalOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.3);
    opacity: 0;
    transition: opacity 0.3s;
    &.show {
        opacity: 1;
    }

    /* Library bug: ListLayer & ItemsList need flex:1 to propagate the height constraint */
    [data-cy="addContactPop"] [data-cy*="items-layer"],
    [data-cy="addContactPop"] [role="listbox"] {
        flex: 1;
        min-height: 0;
    }

    ${mobileMedia} {
        background: transparent;
        [data-cy="addContactPop"].show {
            max-height: 90% !important;
            height: 90%;
        }
    }
`;

export const scrollWrap = styled.div`
    height: 100%;
    ${scrollbar}
`;
